import { HasuraAuthClient } from '@nhost/hasura-auth-js';
import { HasuraStorageClient } from '@nhost/hasura-storage-js';
import { NhostFunctionsClient } from '../clients/functions';
import { NhostGraphqlClient } from '../clients/graphql';
var NhostClient = /** @class */ (function () {
    /**
     * Nhost Client
     *
     * @example
     * const nhost = new NhostClient({ url });
     *
     * @docs https://docs.nhost.io/TODO
     */
    function NhostClient(params) {
        var _this = this;
        if (!params.backendUrl)
            throw 'Please specify a `backendUrl`. Docs: [todo]!';
        var backendUrl = params.backendUrl, refreshIntervalTime = params.refreshIntervalTime, clientStorage = params.clientStorage, clientStorageType = params.clientStorageType, autoRefreshToken = params.autoRefreshToken, autoLogin = params.autoLogin;
        this.auth = new HasuraAuthClient({
            url: "".concat(backendUrl, "/v1/auth"),
            refreshIntervalTime: refreshIntervalTime,
            clientStorage: clientStorage,
            clientStorageType: clientStorageType,
            autoRefreshToken: autoRefreshToken,
            autoLogin: autoLogin,
        });
        this.storage = new HasuraStorageClient({
            url: "".concat(backendUrl, "/v1/storage"),
        });
        this.functions = new NhostFunctionsClient({
            url: "".concat(backendUrl, "/v1/functions"),
        });
        this.graphql = new NhostGraphqlClient({
            url: "".concat(backendUrl, "/v1/graphql"),
        });
        // set current token if token is already accessable
        this.storage.setAccessToken(this.auth.getAccessToken());
        this.functions.setAccessToken(this.auth.getAccessToken());
        this.graphql.setAccessToken(this.auth.getAccessToken());
        // update access token for clients
        this.auth.onAuthStateChanged(function (_event, session) {
            _this.storage.setAccessToken(session === null || session === void 0 ? void 0 : session.accessToken);
            _this.functions.setAccessToken(session === null || session === void 0 ? void 0 : session.accessToken);
            _this.graphql.setAccessToken(session === null || session === void 0 ? void 0 : session.accessToken);
        });
        // update access token for clients
        this.auth.onTokenChanged(function (session) {
            _this.storage.setAccessToken(session === null || session === void 0 ? void 0 : session.accessToken);
            _this.functions.setAccessToken(session === null || session === void 0 ? void 0 : session.accessToken);
            _this.graphql.setAccessToken(session === null || session === void 0 ? void 0 : session.accessToken);
        });
    }
    return NhostClient;
}());
export { NhostClient };
//# sourceMappingURL=nhost-client.js.map